// Shared content styles for consistent presentation across the app
export const contentStyles = {
  container: 'bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden',
  header: {
    default: 'p-4 border-b border-gray-200',
    user: 'bg-blue-50',
    ai: 'bg-green-50', 
    note: 'bg-green-50',
  },
  headerText: {
    user: 'text-sm font-bold text-blue-600',
    ai: 'text-sm font-bold text-green-600',
    note: 'text-sm font-bold text-green-600',
  },
  content: 'p-4',
  text: 'text-base text-gray-700 leading-relaxed break-words',
  // Paragraph spacing class that can be applied to the markdown container
  markdownContainer: 'markdown-content',
};

export default contentStyles;